webpackJsonp([162898551421021],{

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
		return _react2.default.createElement(
			"main",
			{ className: "container container-page" },
			_react2.default.createElement(
				"h1",
				null,
				"404 - Not Found"
			),
			_react2.default.createElement(
				"h3",
				null,
				"We couldn't find the page you were looking for."
			),
			_react2.default.createElement(
				"p",
				null,
				"Go back to the ",
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: "/" },
					"homepage"
				),
				"."
			)
		);
	};
	
	exports.default = NotFoundPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-8d4e4de49bb79f67fabd.js